module.exports = __webpack_public_path__ + "img/bg-l@2x.4f693aa8.jpg";